<div class="header">
  <h2>{{'SETTINGS.TITLE' | translate}}</h2>
  <h4>{{'SETTINGS.AUTOSEND-HEADER' | translate}}</h4>
</div>

<div class="row m-t-20">
  <div class="col-lg-6 col-md-12">
    <div class="box-choice h-100percent">
      <h5 class="text-center">{{'SETTINGS.AUTOSEND' | translate}}</h5>
      <div class="text-center">
        <input type="radio"
            class="m-t-10 text-center"
            value="autoSend"
            [(ngModel)]="selectedValue"
            (change)="onItemChange()"/>
      </div>
      <p class="m-t-20">{{'SETTINGS.AUTOSEND-SENTENCE' | translate}}</p>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 top-margin">
    <div class="box-choice">
      <h5 class="text-center">{{'SETTINGS.MANUALSEND' | translate}}</h5>
      <div class="text-center">
        <input type="radio"
            class="m-t-10"
            value="manualSend"
            [(ngModel)]="selectedValue"
            (change)="onItemChange()"/>
      </div>
      <p class="m-t-20">{{'SETTINGS.MANUALSEND-SENTENCE-1' | translate}}</p>
      <div class="row align-items-center">
        <div class="col-auto" style="width: fit-content;">
          <p class="m-0" s>{{'SETTINGS.MANUALSEND-SENTENCE-2a' | translate}}</p>
        </div>
        <div class="col-auto">
          <select id="manualSendDaySelectBox"
              class="form-control"
              style="width: auto;display: inline"
              [(ngModel)]="manualSendDay">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
          </select>
        </div>
        <div class="col-auto">
          <p class="m-0">{{'SETTINGS.MANUALSEND-SENTENCE-2b' | translate}}</p>
        </div>
      </div>
      <p class="text-bold font-italic m-t-20">{{'SETTINGS.MANUALSEND-SENTENCE-3' | translate}}</p>
    </div>
  </div>
</div>
<div class="row m-t-20 justify-content-end">
  <div class="col-auto">
    <button class="btn btn-dv p-x-100crem" (click)="save(content)">{{'SETTINGS.SAVE' | translate}}</button>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeConfirmSettingsBox()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <span style="color: #4d5f7a">{{'SETTINGS.CONFIRM-SETTINGS' | translate}}?</span>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-dv p-x-100crem" (click)="confirmSaveSettingsBox(content2)">{{'COMMON.YES' | translate}}</button>
    <button type="button" class="btn btn-close" (click)="closeConfirmSettingsBox()">{{'COMMON.NO' | translate}}</button>
  </div>
</ng-template>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closePasswordBox()">
    <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <label class="text-center">{{'SETTINGS.ENTER-PASSWORD' | translate}}</label>
        <input type="password" class="form-control px-2 text-center" [(ngModel)]="confirmPassword" #passwordInput />
        {{ passwordInput.focus() }}
        <p class="text-red" *ngIf="passwordErrorMessage">{{passwordErrorMessage}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-dv p-x-100crem" (click)="enterPasswordBox(content3)">{{'COMMON.OK' | translate}}</button>
    <button type="button" class="btn btn-close" (click)="closePasswordBox()">{{'COMMON.CANCEL' | translate}}</button>
  </div>
</ng-template>

<ng-template #content3 let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeSavedSuccessfullyBox()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <span style="color: #4d5f7a">{{this.updateSettingsMessage}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-dv p-x-100crem" (click)="closeConfirmSettingsBox()">{{'COMMON.OK' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.component.html